import { render, staticRenderFns } from "./DelegationManagementApproval.vue?vue&type=template&id=788688f6&scoped=true"
import script from "./DelegationManagementApproval.vue?vue&type=script&lang=js"
export * from "./DelegationManagementApproval.vue?vue&type=script&lang=js"
import style0 from "./DelegationManagementApproval.vue?vue&type=style&index=0&id=788688f6&prod&scoped=true&lang=css"
import style1 from "./DelegationManagementApproval.vue?vue&type=style&index=1&id=788688f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788688f6",
  null
  
)

export default component.exports